<template>
  <div>
    <b-modal v-model="deleteModal.show" title="刪除警告" ok-only>
      <template #modal-footer>
        <button
          class="btn btn-success btn-sm m-1"
          @click="functionDelete"
        >
          確定
        </button>
      </template>
      <p class="my-4">請問確定要刪除此筆資料嗎?</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
        //API設定區
        apiLatestNews: (data) => this.userRequest.post("bicd/LatestNews", data),
        apiFAQ: (data) => this.userRequest.post("bicd/FAQ", data),
        apiLinks: (data) => this.userRequest.post("bicd/Links", data),
        apiJournal: (data) => this.userRequest.post("bicd/Journal", data),
        apiAccountGroup:(data) => this.userRequest.post("bicd/AccountGroup",data),
        apiUserInfo:(data) => this.userRequest.post("bicd/UserInfo",data),
        apiBanner:(data) => this.userRequest.post("bicd/Banner",data),
        apiMember:(data) => this.userRequest.post("bicd/Member",data),
    };
  },
  props: ["deleteModal"],
  methods: {
    toastShow() {
      this.$bvToast.toast("刪除成功", {
        title: "提示",
        solid: true,
      });
      this.$emit("init");
    },
    functionDelete() {
      if(this.deleteModal.type == "AccountGroup"){
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          ACCOUNT_GROUP_DELETE: {
            AG_ID: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
            typeId: this.deleteModal.classes,
            typeParentId: this.deleteModal.parent,
          },
        };
        this.FunctionToken(this.AccountGroup, json);
      }else if(this.deleteModal.type == "Account"){
        let json = {
          TYPE:"DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          User_Info_DELETE: {
            userId: this.deleteModal.id,
            typeId: this.deleteModal.classes,
            typeParentId: this.deleteModal.parent,
          },
        }
        this.FunctionToken(this.AccountDelete ,json);
      } else if (this.deleteModal.type == "Banner"){
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          Banner_DELETE: {
            bannerId: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
            typeId: this.deleteModal.classes,
            typeParentId: this.deleteModal.parent,
          },
        };
        this.FunctionToken(this.BannerDelete ,json);
      } else if (this.deleteModal.type == "LatestNews") {
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          LatestNews_DELETE: {
            id: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
            typeId: this.deleteModal.classes,
            typeParentId: this.deleteModal.parent,
          },
        };
        this.FunctionToken(this.LatestNewsDelete, json);
      } else if (this.deleteModal.type == "FAQ") {
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          FAQ_DELETE: {
            id: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
            typeId: this.deleteModal.classes,
            typeParentId: this.deleteModal.parent,
          },
        };
        this.FunctionToken(this.FAQDelete, json);
      } else if (this.deleteModal.type == "Links") {
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          Links_DELETE: {
            id: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
          },
        };
        this.FunctionToken(this.LinksDelete, json);
      } else if (this.deleteModal.type == "Journal") {
        let json = {
          TYPE: "DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          Journal_DELETE: {
            id: this.deleteModal.id,
            langurage: this.deleteModal.langurage,
          },
        };
        this.FunctionToken(this.JournalDelete, json);
      } else if(this.deleteModal.type == "Member"){
        let json= {
          TYPE:"DELETE",
          VerifyCode:this.deleteModal.VerifyCode,
          Member_DELETE:{
            id:this.deleteModal.id,
            langurage: this.deleteModal.langurage,
          }
        };
        this.FunctionToken(this.MemberDelete, json);
      } 
      this.deleteModal.show = false;
    },
    //讀取API
    LatestNewsDelete(data) {
      this.apiLatestNews(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    FAQDelete(data) {
      this.apiFAQ(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    LinksDelete(data) {
      this.apiLinks(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    JournalDelete(data) {
      this.apiJournal(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AccountGroup(data){
      this.apiAccountGroup(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AccountDelete(data){
      this.apiUserInfo(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if (json.Status) {
            this.toastShow();
            this.$router.go(0);
          } else {
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    BannerDelete(data){
      this.apiBanner(data)
        .then((res) => {
          let json = JSON.parse(res.data);
          if(json.Status){
            this.toastShow();
            this.$router.go(0);
          }else{
            alert(json.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        })
    },
    MemberDelete(data){
      this.apiMember(data)
      .then((res) => {
        let json = JSON.parse(res.data);
        if(json.Status){
          this.toastShow();
          this.$router.go(0);
        }else{
          alert(json.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
    }
  },
};
</script>